import { useTranslations } from "use-intl";
import { RecurrenceFrequency } from "gql/graphql";

const LABEL_KEYS = {
  [RecurrenceFrequency.Daily]: "Every day",
  [RecurrenceFrequency.Weekly]: "Every week",
  [RecurrenceFrequency.Monthly]: "Every month",
  [RecurrenceFrequency.Quarterly]: "Every quarter",
  [RecurrenceFrequency.Yearly]: "Every year",
} as const;

/**
 * Слово для частоты повтора («Каждый месяц»). Одно на бейдж, форму и фильтр,
 * чтобы серия называлась одинаково на всех экранах.
 */
export function useFrequencyLabel() {
  const t = useTranslations("TaskRecurrence");

  return (frequency: RecurrenceFrequency) => t(LABEL_KEYS[frequency]);
}
